import React from 'react';
import { motion } from 'framer-motion';
import { GALLERY } from '../../data/content';

export const Gallery = () => {
  return (
    <section
      id="work"
      className="relative py-24 md:py-40 bg-[#102234] text-white overflow-hidden"
      data-testid="gallery-section"
    >
      <div className="absolute top-1/4 left-0 w-[500px] h-[500px] rounded-full bg-[#C9A84C]/12 blur-[140px] pointer-events-none" />
      <div className="absolute bottom-0 right-0 w-[400px] h-[400px] rounded-full bg-[#F9F7F4]/8 blur-[120px] pointer-events-none" />
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
        <div className="grid md:grid-cols-12 gap-8 mb-16">
          <div className="md:col-span-6">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
              className="flex items-center gap-3 mb-6"
            >
              <div className="h-px w-12 bg-[#C9A84C]" />
              <span className="text-[#C9A84C] text-xs tracking-[0.4em] uppercase">
                Selected Work
              </span>
            </motion.div>
            <motion.h2
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8, delay: 0.1 }}
              className="font-serif leading-[1] tracking-tight"
              style={{ fontSize: 'clamp(2.5rem, 6vw, 5rem)' }}
            >
              Spaces we've
              <br />
              <span className="italic font-light text-[#C9A84C]">brought to life.</span>
            </motion.h2>
          </div>
          <div className="md:col-span-5 md:col-start-8 flex items-end">
            <p className="text-base md:text-lg text-white/60 max-w-md font-light">
              A glimpse into the homes, offices, and properties our team has
              transformed across DC, Maryland, and Virginia.
            </p>
          </div>
        </div>

        {/* Asymmetric grid */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-5">
          {GALLERY.map((g, idx) => {
            const tall = g.span === 'tall';
            return (
              <motion.div
                key={g.src}
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: '-50px' }}
                transition={{
                  duration: 0.7,
                  delay: (idx % 4) * 0.08,
                  ease: [0.16, 1, 0.3, 1],
                }}
                className={`group relative overflow-hidden bg-[#0A2540] cursor-pointer ${
                  tall ? 'row-span-2 aspect-[3/5]' : 'aspect-[4/5] md:aspect-[5/4]'
                }`}
                data-testid={`gallery-item-${idx}`}
              >
                <img
                  src={g.src}
                  alt={g.label}
                  className="absolute inset-0 w-full h-full object-cover transition-transform duration-1000 group-hover:scale-110"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0D1B2A] via-transparent to-transparent opacity-60 group-hover:opacity-90 transition-opacity duration-500" />
                <div className="absolute inset-x-0 bottom-0 p-5 md:p-6 translate-y-2 group-hover:translate-y-0 transition-transform duration-500">
                  <div className="text-[#C9A84C] text-[10px] tracking-[0.3em] uppercase mb-1">
                    0{idx + 1}
                  </div>
                  <div className="font-serif text-lg md:text-xl">{g.label}</div>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
